import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Icon, Button, IconButton } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as paramActions from '../../components/paramHistory/store/actions';
import TableCellTooltip from '../../components/TableCellTooltip';
import * as HelperFunctions from '../../components/helpers'; 

let moment = require('moment');

const styles = theme => ({
    layoutRoot: {},
});

class CourseLessonList extends Component {

    constructor(props) {
        super(props);

        const allEventList =
            props.quizzes.map(quiz => {
                return {
                    EventName: quiz.QuizName,
                    StartTime: quiz.StartTime,
                    EndTime: quiz.EndTime,
                    id: quiz.quiz_id,
                    EventType: 'quiz'
                }
            })
                .concat(
                    props.assignments.map(assignment => {
                        return {
                            EventName: assignment.AssignmentName,
                            StartTime: assignment.StartTime,
                            EndTime: assignment.EndTime,
                            id: assignment.assignment_id,
                            EventType: 'assignment'
                        }
                    })
                )
        this.state = { eventList: allEventList }
    }

    handleRowClick(page_type, event) {
        this.props.saveLesson(this.props.currentLesson, this.props.assignments, this.props.quizzes, this.props.unscheduled)
        if (this.props.courseBuilder.active) {
            this.props.updateParams({
                active: true,
                lesson_id: this.props.lesson_id,
                startingPoint: this.props.courseBuilder.active && this.props.courseBuilder.startingPoint === 'course' ? 'course' : 'lesson',
                LessonName: this.props.currentLesson.LessonName
            });
        }

        this.props.history.push(`/${event.EventType}/${page_type}/${event.id}`);
    }

    render() {
        const { classes } = this.props;

        return (
            <ReactTable
                columns={[
                    {
                        Header: "Event Name",
                        Cell: row => (
                            <TableCellTooltip
                                item={row.original.EventName}
                                chars={20}
                            />
                        )

                    },
                    {
                        Header: "Event Type",
                        accessor: a => a.EventType.charAt(0).toUpperCase() + a.EventType.slice(1),
                        id: "EventType"
                    },
                    {
                        Header: "Start",
                        accessor: a => a.StartTime ? moment(a.StartTime, 'HH:mm:ss').format('hh:mm A') : 'Unscheduled',
                        sortMethod: (a, b) => {
                            return moment(a, 'hh:mm A').format('HH:mm:ss') > moment(b, 'hh:mm A').format('HH:mm:ss') ? 1 : -1;
                        },
                        id: "StartTime"
                    },
                    {
                        Header: "End",
                        accessor: a => a.EndTime ? moment(a.EndTime, 'HH:mm:ss').format('hh:mm A') : 'Unscheduled',
                        sortMethod: (a, b) => {
                            return moment(a, 'hh:mm A').format('HH:mm:ss') > moment(b, 'hh:mm A').format('HH:mm:ss') ? 1 : -1;
                        },
                        id: "EndTime"
                    },
                    {
                        Header: "",
                        Cell: row => (
                            <div className="flex items-center">
                                {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "lesson", "read") || this.props.auth.user.role === 'student' ? null :
                                    <IconButton
                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.handleRowClick('detail', row.original);
                                        }}
                                    >
                                        <Icon>library_books</Icon>
                                    </IconButton>
                                }
                                {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "lesson", "edit") || this.props.match.params.view_type === 'detail' ? null :
                                    <IconButton
                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.handleRowClick('edit', row.original);
                                        }}
                                    >
                                        <Icon>border_color</Icon>
                                    </IconButton>
                                }


                            </div>
                        )
                    }
                ]}
                data={this.state.eventList}
                defaultPageSize={25}
                className="-striped -highlight"
                noDataText="No Events Found"
            />
        );
    }


}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        saveLesson: Actions.saveLesson,
        updateParams: paramActions.updateCourseBuilderParams
    }, dispatch);
}

function mapStateToProps({ paramHistory, auth }) {
    return {
        auth,
        courseBuilder: paramHistory.courseBuilder
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseLessonList)));


// WEBPACK FOOTER //
// src/main/content/lesson/LessonEventList.js